import type { Instant } from "@js-joda/core";
import { ConvertToInstant } from "src/utilities/DateUtils";
import {
  LIST_DESCRIPTION,
  LIST_FILE,
  LIST_NAME,
} from "src/lists/forms/ListForm";

export type ListStatus = "READY" | "FAILED" | "IN_PROGRESS";

export class List {
  public listName: string;
  public listUuid: string;
  public description: string;
  public fileName: string;
  public firstCreated: Instant;
  public listStatus: ListStatus;
  public rowsSubmitted: number;
  public rowsUploaded: number;
  public file: File;

  constructor(obj?: any) {
    if (obj) {
      this.listName = obj.listName;
      this.listUuid = obj.listUuid;
      this.description = obj.description;
      this.fileName = obj.fileName;
      this.firstCreated = ConvertToInstant(obj.firstCreated);

      this.listStatus = obj.listStatus;
      this.rowsSubmitted = obj.rowsSubmitted;
      this.rowsUploaded = obj.rowsUploaded;
    }
  }

  public toJSON(): object {
    return {
      listName: this.listName,
      description: this.description,
    };
  }

  public toFormData(): FormData {
    const formData: FormData = new FormData();
    formData.append(LIST_NAME, this.listName);
    formData.append(LIST_DESCRIPTION, this.description);
    formData.append(LIST_FILE, this.file);
    return formData;
  }
}

export default List;
